import React from 'react';
import Banner from './Components/banner';
import GemBan from '../../Assets/images/education-web/gemstone-ban.png';
import { Col, Container, Row } from 'react-bootstrap';

import BlueSap from '../../Assets/images/education-web/blue-sap.png';
import YellowSap from '../../Assets/images/education-web/yellow-sap.png';
import PinkSap from '../../Assets/images/education-web/pink-sap.png';
import GreenSap from '../../Assets/images/education-web/green-sap.png';
import RedSap from '../../Assets/images/education-web/red-sap.png';
import Clarity from '../../Assets/images/education-web/clarity.png';
import Gems from '../../Assets/images/education-web/gems.png';
import Help from './Components/help';
import Scrollspy from 'react-scrollspy';

import Loose from '../../Assets/images/education-web/loose.svg';
import Ring from '../../Assets/images/education-web/ring.svg';
import Gem from '../../Assets/images/education-web/gems.svg';
import Fine from '../../Assets/images/education-web/fine.svg';
import { Link } from 'react-router-dom';



const GemstoneEducation = () => {
  return (
    <>
        <Banner title={'Gemstones'} bannerImg={GemBan} nestedBreadCrumb />

        <div className='content-wrapper'>
            <Container>
                <ul className='education-tabs'>
                    <li className=''>
                        <Link to="/education/loose-diamonds-education">
                            <img src={Loose} alt='' />
                            <h3>Loose Diamonds</h3>
                        </Link>
                    </li>

                    <li>
                        <Link to="/education/engagement-ring-education">
                            <img src={Ring} alt='' />
                            <h3>Engagement Ring</h3>
                        </Link>
                    </li>

                    <li className='active'>
                        <Link to="/education/gemstone-education">
                            <img src={Gem} alt='' />
                            <h3>Gemstones</h3>
                        </Link>
                    </li>

                    <li>
                        <Link to="/education/wedding-ring-education">
                            <img src={Ring} alt='' />
                            <h3>Wedding Ring</h3>
                        </Link>
                    </li>

                    <li>
                        <Link to="/education/fine-jewellery-education">
                            <img src={Fine} alt='' />
                            <h3>Fine jewellery</h3>
                        </Link>
                    </li>
                </ul>
            </Container>

            <Container>
                <h2 className='heading'>Table of Content</h2>
                <ul className='table-of-content mt-4'>
                    <li>
                        <a href="#section-1">
                            <h4>Sapphires</h4>
                            <p>Renowned for its rich variation in different colors and hues.</p>
                            <img src={Gems} alt="" />
                        </a>
                    </li>
                    <li>
                        <a href="#section-2">
                            <h4>Green Emerald</h4>
                            <p>Its striking green color makes the emerald a very attractive.</p>
                            <img src={Gems} alt="" />
                        </a>
                    </li>
                    <li>
                        <a href="#section-3">
                            <h4>Red Rubies</h4>
                            <p>Rubies add a striking complement when set in an jewellery.</p>
                            <img src={Gems} alt="" />
                        </a>
                    </li>
                    <li>
                        <a href="#section-4">
                            <h4>Gemstones Anatomy</h4>
                            <p>The valuation of a gemstone is done using the 4C’s.</p>
                            <img src={Gems} alt="" />
                        </a>
                    </li>
                </ul>
            </Container>

            <Row className='m-0 main-content'>
                <Col xl={2} className='p-0 d-xl-block d-none'>
                    <div className='sticky-breadcrumb mt-100 px-5'>
                        <h4>Table of Content</h4>
                        <Scrollspy offset={200} items={ ['section-1', 'section-2', 'section-3', 'section-4'] } currentClassName="is-current">
                            <li><a href="#section-1">Sapphires</a></li>
                            <li><a href="#section-2">Green Emerald</a></li>
                            <li><a href="#section-3">Red Rubbies</a></li>
                            <li><a href="#section-4">Gemstone Anatomy</a></li>
                        </Scrollspy>
                    </div>
                </Col>

                <Col xl={8} lg={12} className='px-3'>
                    <h2 className='heading mt-80' id="section-1">Gemstones</h2>
                    <p className='mt-3'>Gemstones are mined from the Earth’s crust. These gorgeous rocks are available in every virtually imaginable color. These beautiful minerals infuse fine jewellery to give it a natural brilliance. These are categorized based on their characteristics, chemical composition, lustre, availability, color, inclusions, rarity and demand as precious or semi-precious. Their aesthetic value makes them attractive which, makes them a perfect choice for jewellery. Gemstones can be set in with a pair of earrings, a bracelet, an engagement ring, a necklace, etc. Before putting them to use, they need to be cut and polished. Moreover, since ancient times, gemstones have been recognized as birthstone for each month and are a symbol to commemorate special events and milestones. The most popular gemstones are Sapphire, Ruby, Emerald, Topaz, Tanzanite, Amethyst, Opal, Peridot, Citrine, Aquamarine, etc.</p>

                    <Row className='mt-80'>
                        <Col md={3}>
                            <img src={BlueSap} alt='' />
                        </Col>

                        <Col md={9} className='align-self-center'>
                            <h2 className='heading' id="section-1">Sapphires</h2>
                            <p>Renowned for its rich variation in different colors and hues, the name derives from Latin sapphirus, meaning blue, although they exist in many others colors like yellow, green, pink, black, brown, and grey. Blue is the most popular and the most associated color with sapphire. These colors are created by variations in minerals like titanium, iron, and chromium.</p>
                            <p>The highest quality sapphires are mined and found in India, Myanmar. Cambodia, Thailand, Vietnam, Madagascar, Australia, Montana, Brazil, Tanzania, and North Carolina are some countries where sapphires can be found and extracted. The Mohs’ scale measures the hardness of precious gemstones. 9.00 on the Mohs scale makes them the second hardest substance on Earth after diamond.</p>
                            <p>Sapphires are a popular choice for a special occasion as it symbolizes commitment, happiness, serenity, and romance. Sapphires can be set in an engagement ring, tennis bracelet, or earrings.</p>
                        </Col>
                    </Row>

                    <Row className='mt-80' id="section-2">
                        <Col md={8}>
                            <h3 className='sub-heading'>Green Emeralds</h3>
                            <p>Its striking green color makes the emerald a very attractive and popular gemstone for rings and fine jewellery. Emeralds derives its name from the Greek word smaragdus, meaning green gem. It belong s to the mineral family of Beryl that also includes Aquamarines. The color of emerald comes from a small amount of naturally occurring chromium. The color, cut, clarity, and size of an emerald determine its value.</p>
                            <p>The history of emeralds suggests its mining began in Egypt as emeralds were buried with mummies to preserve the spirits of the dead. Today, the best quality emeralds are found in Columbia, Brazil, Nigeria, Tanzania, Zambia, Afghanistan, Somalia, South Africa, Spain, Switzerland, Madagascar and some parts of the United States. The Colombian mines of Muzo, Coscuez, and Chivor being the most famous, followed by Zambia.</p>
                            <p>Emeralds are the birthstone for the month of May. These beautiful stones represent love, prosperity, and overall happiness. It measures 7.5 to 8 on the Moh’s Scale. The bright and vivid green color emeralds are the most valuable.</p>
                        </Col>

                        <Col md={4}>
                            <img src={GreenSap} alt='' />
                        </Col>
                    </Row>

                    <Row className='mt-80' id="section-3">
                        <Col md={3}>
                            <img src={RedSap} alt='' />
                        </Col>
                        <Col md={9} className='align-self-center'>
                            <h3 className='heading mt-md-0 mt-4'>Red Rubies</h3>
                            <p>Ruby is named from the Latin word Ruber, meaning red. Rubies are available in a diverse range of hues ranging from near-burgundy to pale pink. The variation in its color determines its price. The darker and brighter the stone, the more costly it will be. Ruby's price can also be determined by other considerations such as clarity, cut, and size of the ruby.</p>
                            <p>Although the stone is popularly mined in Myanmar, Sri Lanka, Tanzania, Vietnam, Mozambique, Thailand, and Kenya, various parts of the United States are some other locations of the world that produce Ruby. Some rubies are priced higher than diamonds and are the most expensive rubies. These are said to come from Burma and are called Burmese rubies.</p>
                            <p>Ruby is the birthstone for the month of July. Rubies add a striking complement when set in an engagement ring or worn in earrings or a pendant. Sapphires and Rubies are both from the corundum family. Rubies represent love and passion and is believed to provide energy and enthusiasm.</p>
                        </Col>
                    </Row>


                    <Row className='mt-80' id="section-4">
                        <Col md={12} className='mb-md-4 mb-0'><h2 className='heading'>Gemstone Anatomy</h2>
                        <p>The valuation of a gemstone is done using the 4C’s. The 4C’s are carat, cut, color, and clarity. Having a proper understanding of the 4C’s is vital before buying them. The 4C’s will help in examining the correct value of a gemstone.</p>
                        </Col>
                        <Col md={8}>
                            <h3 className='sub-heading'>Clarity</h3>
                            <p>The clarity of a gemstone refers to its internal and external flaws. The fewer inclusions it will contain, the better grading it will have, and the more valuable the colored stone will be. The clarity of a gemstone depends on its type. Very clear stones are graded- AAA clarity, and semi clean stones are of AA clarity. Some gemstones of the highest possible quality are graded- AAAA.</p>
                            <p>Tiny crystals of a mineral, small gas bubbles, minute liquid filled pockets, internal fractures or cleavages, or any other matter visible inside the stone is an inclusion. Any external factors like scratches, abrasions, chips or spots are blemishes.</p>
                            <p>The cost of a diamond is highly affected by inclusion. Some flaws in a gemstone are even visible to the eye. Gemstone grading is not as rigid as diamond grading.</p>

                            <h3 className='sub-heading mt-4'>Color</h3>
                            <p>Each gemstone has a unique distinguishing color. Color is a crucial factor that affects the price of a colored stone. For better analysis, it is essential to understand different color parameters. A gemstone says sapphire can have a different color intensity, shade, purity, saturation and tone. Hue, tone and saturation are three main parameters used for determining the color of a gemstone.</p>
                            <p>Hue represents the primary color of the gemstone. Identifying hues is very easy. The tone of the colored stone helps identify the intensity of the color from light to dark. Ideally, some color tones look more appealing than others as per the design and the setting of the jewellery. This can vary at times depending on a person’s taste and preference.</p>
                            <p>Saturation describes the intensity of the color present, that is, how much color there is. The most expensive gemstones have the most color saturation. The price of a colored stone can fall if the saturation is low. The brighter the emerald (green), the higher the price.</p>
                        </Col>
                        <Col md={4}>
                            <img src={Clarity } alt='' />
                        </Col>

                        <Col className='mt-4'>
                            <h2 className='sub-heading'>Cut</h2>
                            <p>The cut is one of the most important elements in determining the value of a gemstone. The shape of a diamond is its cut. There are various gemstone shapes available like rounds, ovals, hearts, marquise, cushions, pears, emerald or octagonal cut hexagons, half-moons, triangles, and carved gems. A gemstone is graded in four levels- excellent, very good, good, and fair. An excellent cut will reflect on a gemstone's quality. The excellent cut has minimum visible inclusions and extremely deep color that increases its overall visual appearance.</p>
                            <p>Achieving l00% brilliance may not be the final goal of cutting gemstones. Several variables affect the cut of colored stone. If a gemstone is too dark, it is cut shallow, and a shallow cut provides a better color to the gemstones. Deep color can also affect the brilliance of a gemstone as light is absorbed rather than being reflected in extremely dark colored stones. When it comes to very light-coloured stones, the cut is very deep to enhance the overall color of the gemstone.</p>

                            <h2 className='mt-4 sub-heading'>Carat Weight (Size)</h2>
                            <p>Carat is the unit of measurement used for weighing a gemstone. Carat weight is one-fifth of a gram, which is 0.2 grams. One-fifth of a gram would be the weight of a paperclip. Carat should not be confused with karat (10K, 18K), which refers to the purity of gold. Nowadays, gemstones are weighed using an electronic digital scale. There are a variety of stones available in the market, and all these colored stones possess different densities (mass per unit amount). Two similar-sized, identical gemstones might differ in their weights.</p>
                        </Col>
                    </Row>
                </Col>
            </Row>
                

            <Container>
                <Help />
            </Container>
        </div>
    </>
    
  )
}

export default GemstoneEducation;